import WaitingRoom from './WaitingRoom'
export default WaitingRoom